// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import InvoicingList from 'syft-acp-core/entities/InvoicingList'
import PageView from 'syft-acp-core/components/PageView'
import SubNavigationFinance from './SubNavigation'

export const FinanceInvoicing = () => (
  <>
    <SubNavigationFinance />
    <PageView title={['Invoicing', 'Finance']} entityPage>
      <InvoicingList />
    </PageView>
  </>
)
